import { ConfigRepository } from '../repositories/ConfigRepository';
import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { ProdcatApiSdk } from '../../api';
import { Config } from '../domain/entities/Config';

export class ProductServiceStartedUseCase {
    private configRepository: ConfigRepository;
    private prodcatApiSdk: ProdcatApiSdk;
    private configService: Config;
    private configs: string[];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(configs: any) {
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.prodcatApiSdk = diContainer.get(serviceNames.prodcatApiSdk);
        this.configService = diContainer.get(serviceNames.config);
        this.configs = configs;
    }

    public execute = async () => {
        await this.configRepository.getConfigs(this.configs);

        // todo: get to the point when we can remove this
        this.prodcatApiSdk.setQueryFragments(diContainer.get(serviceNames.queryFragments));

        const { features } = this.configService.config;
        const graphqlExtensionVersion = this.configService.config.graphqlExtensionVersion || 'v1';
        this.prodcatApiSdk.setConfigs({ graphqlExtensionVersion, features });
    };
}
